import { render, staticRenderFns } from "./MessageResources.vue?vue&type=template&id=6cc551bd&scoped=true&"
import script from "./MessageResources.vue?vue&type=script&lang=ts&"
export * from "./MessageResources.vue?vue&type=script&lang=ts&"
import style0 from "./MessageResources.vue?vue&type=style&index=0&id=6cc551bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc551bd",
  null
  
)

export default component.exports